// src/routes/webhooksRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';

import Webhooks from '../pages/webhooks/Webhooks';
import CreateWebhook from '../pages/webhooks/CreateWebhook';
import WebhookDetail from '../pages/webhooks/WebhookDetail';
import EditWebhook from '../pages/webhooks/EditWebhook';
import ProtectedRoute from '../components/global/ProtectedRoute';

const webhooksRoutes = (
    <>
        <Route
            path="/settings/integrations/webhooks"
            element={
                <ProtectedRoute requiredPermission="webhooks.manage">
                    <Webhooks />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/integrations/webhooks/new"
            element={
                <ProtectedRoute requiredPermission="webhooks.manage">
                    <CreateWebhook />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/integrations/webhooks/:id"
            element={
                <ProtectedRoute requiredPermission="webhooks.manage">
                    <WebhookDetail />
                </ProtectedRoute>
            }
        />
        <Route
            path="/settings/integrations/webhooks/:id/edit"
            element={
                <ProtectedRoute requiredPermission="webhooks.manage">
                    <EditWebhook />
                </ProtectedRoute>
            }
        />
    </>
);

export default webhooksRoutes;
